import { useSelector } from "react-redux";
import { useMemo, useState } from "react";
import Link from "next/link";
import styles from "./index.module.scss";

export default function Catalog({ onHide }) {
  const { sections } = useSelector((state) => state.sections);
  const sectionsMap = sections ?? {};
  const sectionsTree = useMemo(() => {
    // eslint-disable-next-line no-use-before-define
    return getSectionsTree(sectionsMap);
  }, [sectionsMap]);
  const { contacts } = useSelector((state) => state.contacts);

  const phone = useMemo(() => {
    setTimeout(() => {
      if (typeof window === "object") {
        // eslint-disable-next-line no-unused-expressions
        window?.ct_replace_495 && window?.ct_replace_495();
        // eslint-disable-next-line no-unused-expressions
        window?.ct_replace_812 && window?.ct_replace_812();
        // eslint-disable-next-line no-unused-expressions
        window?.ct_replace_800 && window?.ct_replace_800();
      }
    }, 500);
    return contacts?.phone;
  }, [contacts]);
  const [selectedtId, setRootId] = useState(-1);
  return (
    <>
      <div className={styles.Catalog}>
        <ul className={styles.Sections}>
          <li>
            <div>
              <img src={`/catalog/actions.png`}></img>
            </div>
            <Link href={"/akczii/"}>
              <span>
                {/* eslint-disable-next-line no-use-before-define */}
                {icons.actions}
                <span>Акции</span>
              </span>
            </Link>
          </li>
          {sectionsTree.map((section, id) => (
            <>
              <li
                key={section.ID}
                onClick={() => {
                  if (section.CHILD.length > 0) {
                    setRootId(id);
                  } else {
                    onHide();
                  }
                }}
              >
                <div>
                  <img src={`/catalog/${section.CODE}.png`}></img>
                </div>
                {section.CHILD.length === 0 ? (
                  <>
                    <Link href={section.SECTION_PAGE_URL}>
                      <span>
                        {/* eslint-disable-next-line no-use-before-define */}
                        {icons[section.CODE]}
                        <span>{section.NAME}</span>
                      </span>
                    </Link>
                  </>
                ) : (
                  <span>
                    {/* eslint-disable-next-line no-use-before-define */}
                    {icons[section.CODE]}
                    <span>{section.NAME}</span>
                  </span>
                )}
              </li>
              {selectedtId === id && (
                <div className={styles.SubSections}>
                  {section.CHILD.map((section) => (
                    <Link href={section.SECTION_PAGE_URL} key={section.ID}>
                      <a>
                        <span>{section.NAME}</span>
                      </a>
                    </Link>
                  ))}
                </div>
              )}
            </>
          ))}
        </ul>
        <div className={styles.Links}>
          <Link href="/faq/">Покупателям</Link>
          <Link href="/articles/">Статьи и новости</Link>
          <Link href="/about/">О компании</Link>
          <Link href="/contacts/">Контакты</Link>
        </div>
      </div>
      <div className={styles.Phone}>
        <a
          href={`tel:${phone}`}
          className={contacts?.calltouchCode}
          onClick={() => {
            if (
              window.location.href.includes(
                "vnesenie-izmeneniy-v-konstruktsiyu-ts-posle-ustanovki-farkopa_v_moskve",
              )
            ) {
              if (typeof ym !== "undefined") {
                // eslint-disable-next-line no-undef
                ym(20518312, "reachGoal", "mskRegPhoneClick");
              }
            } else if (
              window.location.href.includes(
                "vnesenie-izmeneniy-v-konstruktsiyu-ts-posle-ustanovki-farkopa_v_sankt-peterburge",
              )
            ) {
              if (typeof ym !== "undefined") {
                // eslint-disable-next-line no-undef
                ym(20518312, "reachGoal", "spbRegPhoneClick");
              }
            }
          }}
        >
          <svg
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.1561 19.4473C13.3097 20.3734 15.8896 20.9258 18.9671 20.9258V16.4623L14.5037 15.3465L11.1561 19.4473ZM11.1561 19.4473C6.87004 17.6038 4.26449 14.2808 2.78708 10.883M2.78708 10.883C1.55963 8.06207 1.11328 5.18984 1.11328 3.07192H5.57675L6.69261 7.53539L2.78708 10.883ZM13.3878 8.65125L20.083 1.95605M20.083 1.95605V6.41952M20.083 1.95605H15.6195"
              stroke="#1856C3"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>

          {phone}
        </a>
        <span
          onClick={() => {
            onHide();
          }}
        >
          <svg
            width="16"
            height="10"
            viewBox="0 0 16 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="1.56738"
              y="0.466064"
              width="10.8901"
              height="2"
              transform="rotate(45 1.56738 0.466064)"
              fill="#1856C3"
            />
            <rect
              x="15.71"
              y="1.88013"
              width="10.9729"
              height="2"
              transform="rotate(135 15.71 1.88013)"
              fill="#1856C3"
            />
          </svg>
        </span>
      </div>
    </>
  );
}

function getSectionsTree(sections = {}, parent = null) {
  return Object.values(sections ?? {})
    .filter((section) => +section.IBLOCK_SECTION_ID === +parent)
    .map((section) => {
      return {
        ...section,
        CHILD:
          section.HAS_CHILDS === "Y"
            ? getSectionsTree(sections, section.ID)
            : [],
      };
    })
    .sort((a, b) => a.SORT - b.SORT);
}

const icons = {
  actions: (
    <svg
      width="37"
      height="37"
      viewBox="0 0 37 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="14.418"
        y="1.83252"
        width="7.74658"
        height="7.74658"
        rx="2"
        stroke="#A90D0D"
        strokeWidth="2"
      />
      <rect
        x="1.57031"
        y="14.5674"
        width="7.74658"
        height="7.74658"
        rx="2"
        stroke="#A90D0D"
        strokeWidth="2"
      />
      <rect
        x="14.418"
        y="14.5674"
        width="7.74658"
        height="7.74658"
        rx="2"
        stroke="#A90D0D"
        strokeWidth="2"
      />
      <rect
        x="27.2656"
        y="14.5674"
        width="7.74658"
        height="7.74658"
        rx="2"
        stroke="#A90D0D"
        strokeWidth="2"
      />
      <rect
        x="1.57031"
        y="27.3018"
        width="7.74658"
        height="7.74658"
        rx="2"
        stroke="#A90D0D"
        strokeWidth="2"
      />
      <rect
        x="27.2656"
        y="27.3018"
        width="7.74658"
        height="7.74658"
        rx="2"
        stroke="#A90D0D"
        strokeWidth="2"
      />
    </svg>
  ),
  farkopy: (
    <svg
      width="37"
      height="22"
      viewBox="0 0 37 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.2289 10.1648C11.6721 10.1648 8.78223 12.7317 8.78223 15.8909C8.78223 19.0502 11.6721 21.617 15.2289 21.617C18.7856 21.617 21.6755 19.0502 21.6755 15.8909C21.6755 12.7317 18.7856 10.1648 15.2289 10.1648ZM15.2289 20.0374C12.6724 20.0374 10.5606 18.1616 10.5606 15.8909C10.5606 13.6202 12.6724 11.7444 15.2289 11.7444C17.7853 11.7444 19.8971 13.6202 19.8971 15.8909C19.8971 18.1616 17.7853 20.0374 15.2289 20.0374Z"
        fill="#759EE5"
      />
      <path
        d="M14.1172 14.9031H16.3402V16.8776H14.1172V14.9031Z"
        fill="#759EE5"
      />
      <path
        d="M35.2354 0.0944824H0.779297V13.0276C0.779297 15.1996 2.66883 16.878 5.1141 16.878H6.33674V14.9034H5.1141C4.00261 14.9034 3.11342 14.1136 3.00227 13.0276V6.01806H27.455V13.0276C27.455 14.0149 26.5658 14.8047 25.3432 14.9034H24.1206V16.878H25.3432C27.6773 16.878 29.5669 15.1996 29.5669 13.0276V2.06901H35.1243C35.7912 2.06901 36.2358 1.6741 36.2358 1.08175C36.2358 0.489388 35.9023 0.0944824 35.2354 0.0944824ZM27.455 4.04354H3.00227V2.06901H27.455V4.04354Z"
        fill="#759EE5"
      />
    </svg>
  ),
  elektrika_farkopov: (
    <svg
      width="21"
      height="26"
      viewBox="0 0 21 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.19942 1.03749H16.3031C16.4128 1.03711 16.5209 1.0641 16.6175 1.11602C16.7142 1.16794 16.7963 1.24315 16.8566 1.33484C16.9169 1.42653 16.9533 1.53181 16.9626 1.64113C16.9719 1.75045 16.9538 1.86036 16.9099 1.96092L13.3481 10.2743H19.3523C19.4026 10.2748 19.4516 10.2897 19.4937 10.3172C19.5359 10.3446 19.5692 10.3836 19.59 10.4294C19.6107 10.4752 19.6179 10.526 19.6107 10.5757C19.6036 10.6255 19.5823 10.6722 19.5495 10.7103L7.30495 24.1672C7.27154 24.2172 7.22132 24.2535 7.16342 24.2696C7.10552 24.2857 7.04376 24.2805 6.98936 24.255C6.93495 24.2295 6.8915 24.1853 6.86688 24.1305C6.84226 24.0756 6.83811 24.0138 6.85517 23.9562L8.07008 14.2319H2.44909C2.33992 14.2334 2.23209 14.2078 2.13523 14.1574C2.03837 14.107 1.9555 14.0334 1.89402 13.9432C1.83255 13.853 1.79438 13.7489 1.78294 13.6404C1.77149 13.5318 1.78713 13.4221 1.82844 13.321L6.57752 1.44581C6.62786 1.32284 6.71417 1.21795 6.82514 1.14487C6.93611 1.07178 7.06657 1.03517 7.19942 1.03749Z"
        stroke="#759EE5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  vstavki_pod_kvadrat: (
    <svg
      width="27"
      height="23"
      viewBox="0 0 27 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.6423 2.32363L15.5242 0.596622C15.4019 0.573816 15.2775 0.561377 15.1552 0.55723V0.551011H14.9686C14.9686 0.551011 14.9644 0.551011 14.9624 0.551011L11.0522 0.582109C10.3287 0.466008 9.61546 0.665039 9.03703 1.14396C8.91885 1.2414 8.81104 1.35128 8.70945 1.46738L4.10685 0.596622C3.35634 0.453568 2.61412 0.650526 2.01702 1.14603C1.23126 1.79703 0.779297 2.87926 0.779297 4.11699V18.6732C0.779297 19.8882 1.2209 20.9725 1.99214 21.6504C2.48972 22.0879 3.09096 22.3201 3.71501 22.3201C3.82282 22.3201 3.9327 22.3139 4.04258 22.2993L9.02044 21.6546C9.59058 22.1521 10.2955 22.3823 11.0149 22.3056L14.9085 22.3201V22.3097C14.9831 22.3159 15.0598 22.3201 15.1365 22.3201C15.2443 22.3201 15.3542 22.3139 15.4641 22.2993L24.5096 21.128C25.8241 20.9579 26.8255 19.4486 26.8358 17.6159L26.9084 5.97669C26.9188 4.14187 25.9464 2.57242 24.6444 2.32571L24.6423 2.32363ZM3.85599 20.8584C3.44756 20.9103 3.13865 20.7257 2.94998 20.5599C2.50009 20.1639 2.23057 19.459 2.23057 18.6732V4.11699C2.23057 3.32501 2.49594 2.63255 2.94169 2.26351C3.20914 2.04167 3.50976 1.96082 3.83733 2.02301L7.98589 2.80877C7.86564 3.21306 7.80345 3.65466 7.80345 4.11699V18.6732C7.80345 19.26 7.90918 19.8135 8.10199 20.309L3.85599 20.8584ZM10.9258 20.8522L10.8781 20.8584C10.4717 20.9103 10.1607 20.7257 9.97206 20.5599C9.52217 20.1639 9.25264 19.459 9.25264 18.6732V4.11699C9.25264 3.32501 9.51802 2.63255 9.96377 2.26351C10.2312 2.04167 10.5318 1.96082 10.8573 2.02301L10.9278 2.03545L12.7108 2.02094C12.377 2.60974 12.1946 3.33123 12.1946 4.11699V18.6732C12.1946 19.4901 12.3978 20.2448 12.7647 20.8584L10.9258 20.8522ZM25.3804 17.6055C25.3742 18.7188 24.8144 19.6228 24.3189 19.687L15.2733 20.8584C14.8649 20.9103 14.556 20.7257 14.3673 20.5599C13.9174 20.1639 13.6479 19.459 13.6479 18.6732V4.11699C13.6479 3.32501 13.9133 2.63255 14.359 2.26351C14.5643 2.0935 14.7903 2.00643 15.0328 2.00435H15.0557C15.1199 2.00435 15.1863 2.01057 15.2547 2.02301L24.3707 3.75003C24.887 3.84747 25.4592 4.81775 25.453 5.96632L25.3804 17.6055Z"
        fill="#759EE5"
      />
    </svg>
  ),
  velokrepleniya_na_kryshu: (
    <svg
      width="41"
      height="25"
      viewBox="0 0 41 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M33.4888 9.68726C32.5204 9.68666 31.5616 9.8795 30.6687 10.2544L26.2723 2.71635H30.9539C31.3741 2.71635 31.7771 2.88326 32.0742 3.18038C32.3713 3.47749 32.5382 3.88046 32.5382 4.30065C32.5382 4.55275 32.6384 4.79454 32.8166 4.97281C32.9949 5.15107 33.2367 5.25122 33.4888 5.25122C33.7409 5.25122 33.9827 5.15107 34.1609 4.97281C34.3392 4.79454 34.4394 4.55275 34.4394 4.30065C34.4394 3.37624 34.0722 2.4897 33.4185 1.83605C32.7648 1.1824 31.8783 0.815186 30.9539 0.815186H24.6167C24.4501 0.815634 24.2865 0.859883 24.1423 0.943497C23.9982 1.02711 23.8785 1.14715 23.7954 1.29158C23.7123 1.43601 23.6686 1.59976 23.6687 1.7664C23.6688 1.93305 23.7127 2.09674 23.796 2.24106L25.919 5.88494H16.0789L13.3967 1.29048C13.3135 1.14634 13.1939 1.02659 13.0499 0.943177C12.9058 0.859769 12.7425 0.815634 12.576 0.815186H8.13999C7.88788 0.815186 7.64609 0.915336 7.46783 1.0936C7.28956 1.27187 7.18941 1.51366 7.18941 1.76577C7.18941 2.01787 7.28956 2.25966 7.46783 2.43793C7.64609 2.61619 7.88788 2.71635 8.13999 2.71635H12.0294L14.4059 6.77849L11.6254 10.5776C9.99524 9.68282 8.08566 9.44177 6.28422 9.90339C4.48279 10.365 2.92447 11.4947 1.92552 13.0633C0.926569 14.6319 0.561827 16.5217 0.905316 18.3494C1.2488 20.177 2.27479 21.8055 3.77505 22.9044C5.27532 24.0032 7.13746 24.4901 8.98358 24.2662C10.8297 24.0423 12.5215 23.1244 13.7156 21.6988C14.9097 20.2732 15.5166 18.4466 15.4133 16.5899C15.3099 14.7331 14.504 12.9852 13.159 11.7009L15.4452 8.57825L20.6274 17.4503C20.7108 17.5947 20.8306 17.7146 20.975 17.798C21.1193 17.8814 21.283 17.9255 21.4497 17.9256C21.6169 17.9256 21.781 17.8807 21.925 17.7957C22.1425 17.6687 22.3007 17.4605 22.3649 17.217C22.4291 16.9734 22.3939 16.7143 22.2672 16.4966L17.1863 7.78294H27.0264L29.0274 11.2145C27.6634 12.2716 26.7187 13.7784 26.3615 15.4666C26.0044 17.1549 26.2579 18.9152 27.0769 20.4341C27.896 21.953 29.2275 23.132 30.8343 23.7611C32.4412 24.3903 34.2192 24.4289 35.8518 23.87C37.4845 23.3111 38.8658 22.191 39.75 20.709C40.6342 19.2271 40.9638 17.4795 40.6802 15.7773C40.3966 14.0751 39.5181 12.5288 38.2012 11.4136C36.8843 10.2984 35.2144 9.68662 33.4888 9.68726ZM13.5266 16.975C13.5268 18.1445 13.1464 19.2823 12.4429 20.2165C11.7394 21.1506 10.7509 21.8305 9.62688 22.1533C8.50285 22.4761 7.30429 22.4244 6.21227 22.0058C5.12026 21.5873 4.19411 20.8248 3.57374 19.8334C2.95337 18.8421 2.67248 17.6757 2.7735 16.5106C2.87453 15.3455 3.35198 14.245 4.13373 13.3752C4.91548 12.5054 5.95906 11.9137 7.10682 11.6894C8.25457 11.4651 9.44415 11.6204 10.4958 12.1318L7.3716 16.4094C7.22286 16.6132 7.16116 16.8678 7.20008 17.117C7.239 17.3663 7.37536 17.5899 7.57915 17.7387C7.78293 17.8874 8.03747 17.9491 8.28674 17.9102C8.53602 17.8713 8.75963 17.7349 8.90837 17.5311L12.0294 13.2535C12.9907 14.2539 13.5273 15.5877 13.5266 16.975ZM33.4888 22.3617C32.3882 22.3593 31.3148 22.0198 30.413 21.389C29.5111 20.7582 28.8242 19.8662 28.4445 18.8332C28.0649 17.8002 28.0107 16.6757 28.2894 15.611C28.5681 14.5463 29.1662 13.5926 30.0033 12.878L32.6681 17.4503C32.7515 17.5947 32.8713 17.7146 33.0156 17.798C33.16 17.8814 33.3237 17.9255 33.4904 17.9256C33.6576 17.9256 33.8217 17.8807 33.9657 17.7957C34.1832 17.6687 34.3414 17.4605 34.4056 17.217C34.4697 16.9734 34.4346 16.7143 34.3079 16.4966L31.6367 11.9164C32.3757 11.646 33.165 11.5408 33.949 11.6082C34.733 11.6756 35.4927 11.914 36.1747 12.3066C36.8567 12.6991 37.4444 13.2363 37.8965 13.8804C38.3486 14.5245 38.6541 15.2598 38.7915 16.0346C38.9288 16.8094 38.8948 17.6049 38.6917 18.3652C38.4886 19.1254 38.1214 19.832 37.616 20.4351C37.1105 21.0382 36.4791 21.5232 35.766 21.856C35.053 22.1889 34.2757 22.3615 33.4888 22.3617Z"
        fill="#759EE5"
      />
    </svg>
  ),
  velokrepleniya_na_farkop: <></>,
  velokrepleniya_na_zadnyuyu_dver: <></>,
  aksessuary_i_zapchasti: <></>,
  bagazhnye_sistemy: <></>,
};
